import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './Vital.styled';
import TextLabel, { TextLabelTypes } from '../../atoms/TextLabel/TextLabel';
import Icon from '../../atoms/Icon/Icon';
import { vitalsDataObjects } from './VitalDisplayData';
import { useTranslation } from 'react-i18next';
import { camelCase } from 'lodash';

/**
 * @type {React.FC<{vital: {
 *   id: number;
 *   title: string;
 *   metric?: string;
 *   stateId?: number;
 *   type: string;
 *   value: string;
 *   organisationId?: number;
 *   normalValueMin?: string;
 *   normalValueMax?: string;
 *   createdAt: string;
 *   updatedAt: string;
 *   isActive: boolean;
 *   isDeleted: boolean;
 * }}>}
 * */
const Vital = ({ vital }) => {
  const vitalDisplayDataObj = vitalsDataObjects[vital.type];
  const { t, i18n } = useTranslation();

  const title = i18n.exists(camelCase(vital.title))
    ? t(camelCase(vital.title))
    : vital.title;

  return (
    <Styled.Wrapper>
      <Styled.IconContainer
        color={
          vitalDisplayDataObj.colors.secondary
            ? vitalDisplayDataObj.colors.secondary
            : 'transparent'
        }
      >
        <Icon
          width="100%"
          height="100%"
          icon={vitalDisplayDataObj.icon}
          color={
            vitalDisplayDataObj.colors.primary
              ? vitalDisplayDataObj.colors.primary
              : '#111B32'
          }
        />
      </Styled.IconContainer>
      <Styled.DataContainer>
        <TextLabel type={TextLabelTypes.LARGE_DARK}>{vital.value}</TextLabel>
        <Styled.Metric
          color={
            vitalDisplayDataObj.colors.primary
              ? vitalDisplayDataObj.colors.primary
              : '#111B32'
          }
        >
          {vital ? vital.metric : ``}
        </Styled.Metric>
      </Styled.DataContainer>
      <Styled.Title>{title}</Styled.Title>
    </Styled.Wrapper>
  );
};

Vital.propTypes = {
  vital: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    metric: PropTypes.string,
    stateId: PropTypes.number,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    organisationId: PropTypes.number,
    normalValueMin: PropTypes.string,
    normalValueMax: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    isDeleted: PropTypes.bool.isRequired,
  }).isRequired,
};

export default Vital;
